<div class="document-line line mt-6"></div>

<div class="mt-n5">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" (navChange)="onNavChange($event)"
        class="nav-tabs bg-transparent profile-page-bar text-center d-flex justify-content-between">

        <li class="me-3" [ngbNavItem]="1">
            <a class="link text-dark" ngbNavLink>
                <span><i class="bi bi-person fs-3 text-light"
                        [ngClass]="{'fs-2 box-shadow-custom': +active === 1, 'fs-3': +active !== 1}"></i></span> <br>
                <br><b>
                    Personal Information</b><span class="text-danger">*</span> <span
                    *ngIf="sectionCompletionData?.profileSection"><i
                        class="bi bi-info-circle bg-transparent text-danger"></i></span>
            </a>
            <ng-template ngbNavContent>
                <app-student-personal-information #personalInfoComp *ngIf="admissionData"
                    [studentDetails]="admissionData" [applicationData]="applicationData"
                    (updatedProfileData)="getUpdatedProfileData($event)">
                </app-student-personal-information>
            </ng-template>
        </li>

        <li class="me-3" [ngbNavItem]="2">
            <a class="link text-dark" ngbNavLink>
                <span> <i class="bi bi-mortarboard fs-3 text-light"
                        [ngClass]="{'fs-2 box-shadow-custom': +active === 2, 'fs-3': +active !== 2}"></i> </span> <br>
                <br>
                <b>Academic Qualification</b><span class="text-danger">*</span> <span
                    *ngIf="sectionCompletionData?.academicSection"><i
                        class="bi bi-info-circle bg-transparent text-danger"></i></span>
            </a>
            <ng-template ngbNavContent>
                <app-student-academic-qualification academicQualificationComp *ngIf="admissionData"
                    [applicationData]="applicationData" [studentDetails]="admissionData"
                    (updatedProfileData)="getUpdatedProfileData($event)">
                </app-student-academic-qualification>
            </ng-template>
        </li>

        <li class="me-3" [ngbNavItem]="3">
            <a class="link text-dark" ngbNavLink>
                <span> <i class="bi bi-award fs-3 text-light"
                        [ngClass]="{'fs-2 box-shadow-custom': +active === 3, 'fs-3': +active !== 3}"></i> </span> <br>
                <br>
                <b>Test Scores</b><span class="text-danger">*</span> <span
                    *ngIf="sectionCompletionData?.testScoreSection"><i
                        class="bi bi-info-circle bg-transparent text-danger"></i></span>
            </a>
            <ng-template ngbNavContent>
                <app-student-competitive-test-scores #competitiveTestInfoComp *ngIf="admissionData"
                    [applicationData]="applicationData" [studentDetails]="admissionData"
                    (updatedProfileData)="getUpdatedProfileData($event)">
                </app-student-competitive-test-scores>
            </ng-template>
        </li>

        <li class="me-3" [ngbNavItem]="4">
            <a class="link text-dark" ngbNavLink>
                <span><i class="bi bi-briefcase fs-3 text-light"
                        [ngClass]="{'fs-2 box-shadow-custom': +active === 4, 'fs-3': +active !== 4}"></i></span> <br>
                <br>
                <b> Work Experience</b>
            </a>
            <ng-template ngbNavContent>
                <app-student-work-experience #workExperienceComp *ngIf="admissionData"
                    [applicationData]="applicationData" [studentDetails]="admissionData"
                    (updatedProfileData)="getUpdatedProfileData($event)">
                </app-student-work-experience>
            </ng-template>
        </li>

    </ul>
</div>


<main class="text-secondary">
    <div [ngbNavOutlet]="nav" class="mt-2 p-2"></div>
</main>